import * as React from "react";
import Svg, { Path, Rect, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

cssInterop(Rect, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { fill: true },
  },
});

type AccountActiveIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
  rectClassName?: string;
};

function AccountActiveIcon({
  className,
  pathClassName = "stroke-white",
  rectClassName = "fill-black",
  ...props
}: AccountActiveIconProps) {
  return (
    <Svg
      width={29}
      height={29}
      viewBox="0 0 29 29"
      fill="none" 
      className={className}
      {...props}
    >
      <Rect x={1} y={1.5} width={26} height={26} rx={6} className={rectClassName} />
      <Path
        d="M6.75 14h15M6.75 21h15M6.75 8h15"
        className={pathClassName}
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </Svg>
  );
}

export default AccountActiveIcon;
